<template>
    <div id="classdetailstu">
        <div class="head">
            <i class="back"
               @click="back()"></i>
            <p class="title">{{name}}（{{score}}分）</p>
        </div>
        <template v-if="loading">
            <div class="wrap"
                 v-if="testData && testData.length">
                <div class="tip">共{{ num }}题( 答对<span>{{num - wrong}}</span>题, 答错<span>{{wrong}}</span>题 )
                </div>
                <div class="question">
                    <div class="sx"
                         v-for="(data,index) in testData">
                        <div class="sx-stem">
                            <div class="judgeicon"
                                 :class="[data.answer==data.right ? 'dui' : 'cuo']">
                            </div>
                            <span class="stem">{{data.subject}}&nbsp;(</span><span class="stem-answer">{{data.answer}}</span>)
                        </div>
                        <div class="answer-wrap">
                            <div class="user">
                                <div class="user-answer">正确答案:</div>
                                <div>{{data.right}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="nowork"
                 v-else>
                <div v-cloak>
                    没有作业数据
                </div>
            </div>
            <div class="bottom_btn">
                <div @click="reward">奖励和评语</div>
            </div>
        </template>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'SRC/components/base/header.vue'
import loadingS from 'SRC/components/base/tealoading.vue';

export default {
    data () {
        return {
            questions: [],
            testData: [],
            qids: "",
            sid: this.$route.params.sid,
            taskId: this.$route.params.taskid,
            user_id: this.$route.params.user_id,
            name: this.$route.params.username,
            classId: this.$route.params.classid,
            score: this.$route.query.score,
            loading: false,
            wrong: null,
        }
    },
    computed: {},
    methods: {
        back () {
            this.$router.go(-1)
        },
        toComment () {
            this.$router.push('/sx/task/classdetail/commentstu/' + this.name + '/' + this.user_id)
        },
        toRemind () {
            this.$router.push('/sx/task/classdetail/remindstu/' + this.name + '/' + this.user_id)
        },
        reward () {
            this.$router.push("/tea/perreward/" + this.sid + "/" + this.taskId + "/" + this.user_id + "?score=" + this.score + "&name=" + this.name);
        }
    },
    created () {
        this.$http.post(API_URL_TASK_API + '/maths/check/quick/stu_detail', {
            "message_id": this.taskId,
            "user_id": this.user_id,
            "unit_class_id": this.classId,
            "user_type": 3,
        }).then(res => {
            this.loading = true;
            if (res.data.response == 'ok') {
                this.testData = res.data.data.result;
                let wrong = 0
                this.testData.forEach(d => {
                    if (d.result != 1) {
                        wrong = wrong + 1
                    }
                });
                this.wrong = wrong;
                this.num = this.testData.length
            }
        })
    },
    components: {
        loadingS,
        headers,
    },
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

[v-cloak] {
    display: none;
}

#classdetailstu {
    min-height: 100vh;
}

.wrap {
    padding-bottom: 96px / $ppr;
}
.head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;

    .back {
        position: absolute;
        top: 0;
        left: 0;
        width: 76px / $ppr;
        height: 96px / $ppr;
        background: url(./img/choose_back.png) no-repeat center;
        background-size: 18px / $ppr 34px / $ppr;
    }

    .title {
        width: 100%;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 34px / $ppr;
        color: #fff;
        text-align: center;
    }
}

.tip {
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    font-size: 30px / $ppr;
    background-color: $c-fbg;
    padding: 0 $w;
    margin-bottom: $w;
    span {
        color: #ff6600;
    }
}
.bottom_btn {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 96px / $ppr;
    width: 100%;
    z-index: 8;
    div {
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        background: #5e89ef;
        text-align: center;
        font-size: 30px / $ppr;
        color: #fff;
        line-height: 96px / $ppr;
    }
}

.question {
    font-family: Monospace;
    .order {
        color: $c-theme;
    }
    .title {
        background-color: $c-fbg;
        border-bottom: 1px / $ppr solid #e8e8e8;
        padding: $w $w;
    }
    .img-wrap {
        display: flex;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        flex-shrink: 0;
        -webkit-flex-shrink: 0;
        justify-content: center;
        -webkit-justify-content: center;
        img {
            display: inline-block;
        }
    }
    .ask {
        margin-bottom: $w;
        background-color: $c-fbg;
    }
    .subtitle-wrap {
        position: relative;
        border-bottom: 1px / $ppr solid #e8e8e8;
    }
    .subtitle {
        padding: $w $w;
    }
    .option {
        padding: $w $w;
        border-bottom: 1px / $ppr solid #e8e8e8;
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        .spot {
            display: block;
            width: $w * 2;
            height: $w * 2;
            line-height: $w * 2;
            text-align: center;
            border: 1px / $ppr solid #e8e8e8;
            border-radius: $w;
            margin-right: $w;
        }
    }
}

.answer-wrap {
    padding: $w $w;
    background-color: #fff;
    .user {
        color: #999;
        font-size: 30px / $ppr;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        -webkit-align-items: center;
        margin-right: 36px / $ppr;
        .user-answer {
            padding: 6px / $ppr 8px / $ppr;
            margin-right: $w;
        }
    }
}

.quest_title {
    padding: 24px / $ppr;
    line-height: 46px / $ppr;
    font-size: 30px / $ppr;
    color: #333;
    border-bottom: 1px / $ppr solid #e8e8e8;
    background: #fff;
    @include displayFlex();
    .tit_num {
        width: 48px / $ppr;
    }
    div {
        @include flex();
    }
}

.quest_con {
    position: relative;
}

.sx {
    background-color: $c-fbg;
    border-bottom: 1px / $ppr solid #e8e8e8;
    .sx-stem {
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        padding: 0 $w;
        font-size: 30px / $ppr;
        border-bottom: 1px / $ppr solid #eaeaea;
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        position: relative;
    }
    .stem-answer {
        color: #5d89ef;
    }
}

.sx:last-child {
    border: 0;
}

.nowork {
    color: $c-light;
    text-align: center;
    margin-top: 304px / $ppr;
}

.judgeicon {
    position: absolute;
    right: 24px / $ppr;
    top: 0.6rem;
    z-index: 2;
    width: 40px / $ppr;
    height: 36px / $ppr;
    //background-color: #21BF63;
}

.dui {
    background-image: url(img/icon_dui.png);
    background-size: cover;
}

.cuo {
    background-image: url(img/icon_cuo.png);
    background-size: cover;
}

.exercises {
    background-color: #fff;
    position: relative;
}

.block {
    display: block !important;
}
</style>
